import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FeriadoDTO } from "@shared/models/facturacion/FeriadoDTO";
import { ManagementService } from "@management/management.service";
import { MessageService } from "@shell/message.service";
import { SharedService } from '@shared/shared.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrl: './holiday.component.scss'
})
export class HolidayComponent implements OnInit {

  @Input() detail: string;
  @Input() selectedDate: Date;
  @Input() responsable: string = "Thomsen, Octavio";
  @Input() activo: boolean;
  guardandoFeriado: boolean = false;
  nuevoFeriado: boolean = true;
  feriado: FeriadoDTO = new FeriadoDTO();
  title: string = 'Editar';
  guardando: boolean = false;
  fechaMostrar: string = '';

  constructor(public activeModal: NgbActiveModal,
              private datePipe: DatePipe,
              private sharedService: SharedService,
              private managementService: ManagementService,
              private messageService: MessageService) {}

  ngOnInit(): void {
    this.fechaMostrar = this.datePipe.transform(this.selectedDate, 'dd/MM/YYYY');
    this.title = this.detail ?? 'Agregar';
    if(this.detail) this.nuevoFeriado = false;
  }

  async onSave() {
    this.guardandoFeriado = true;
    this.feriado.fecha = this.sharedService.formatDate(this.selectedDate.getFullYear(), this.selectedDate.getMonth() + 1, this.selectedDate.getDate(), 0, 0);
    this.feriado.motivo = this.detail;
    this.feriado.activo = this.activo;
    try {
      this.feriado = await this.managementService.crearModificarFeriados(this.feriado);
      this.guardandoFeriado = false;
      this.activeModal.close(this.feriado);
    }
    catch (error) {
      this.messageService.showErrorMessage("Error en la llamada a backend: " + error.message + " descripcion: " + error.descripcion);
      this.guardandoFeriado = false;
      this.activeModal.dismiss([]);
    }
  }


  cambiarActivo() {
    this.activo = !this.activo;
  }
}
